import styled from 'styled-components';

export const AppearanceStyled = styled.div`
  .Polaris-Banner.Polaris-Banner--withinPage {
    margin-bottom: -16px;
    color: var(--p-color-text-critical);
    .Polaris-Box {
      background-color: var(--p-color-bg-surface-critical);
    }
  }
  .Polaris-Banner--textCriticalOnBgFill.Polaris-Banner--textCriticalOnBgFill.Polaris-Banner--textCriticalOnBgFill svg path {
    fill: var(--p-color-text-critical);
  }
`;
